import lodash from 'lodash';

const pollsDataNormalizer = (componentData: $TSFixMe) => {
  return {
    ...lodash.omit(componentData, ['siteToken', 'config.enableVoteRole']),
    poll: normalizePoll(componentData.poll),
  };
};

const normalizePoll = (poll: $TSFixMe) => {
  const blackList = [
    'anonymousCount',
    'count',
    'creatorFlag',
    'ownVotes',
    'latestVoters',
    'rating',
  ];

  const normalizedPoll = lodash.omit<{ options: any }>(poll, blackList);
  normalizedPoll.options = poll.options.map((option: $TSFixMe) => lodash.omit(option, blackList));
  return normalizedPoll;
};

export default pollsDataNormalizer;
